import { RootState } from 'types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Mode, updateMode } from 'core/slices/session';
import { IPlayerState, updatePlayerState } from 'core/slices/player';
import { useAppDispatch } from 'core/store/hooks';

export default function SetMode({ mode }: { mode: Mode }) {
  const m: Mode = useSelector((state: RootState) => state.session.mode);
  const state: IPlayerState = useSelector((state: RootState) => state.core.player.state);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (mode !== m) dispatch(updateMode(mode));
    //if (!state.paused) dispatch(updatePlayerState({ paused: true }));
  }, [mode]);

  return null;
}
